export class ProfilePicture {
  id?: number;
  fileName?: string;
  fileType?: string;
  uploadSignedUrl?: string;
  url?: string;
}
